export class UnauthorizedError extends Error {
  response: any;

  constructor(response: any) {
    super("unauthorized");
    Object.setPrototypeOf(this, UnauthorizedError.prototype);

    this.response = response;
    this.name = "UnauthorizedError";
  }
}
